
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/support-request",
      function () {
        return require("private-next-pages/support/support-request/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/support-request"])
      });
    }
  